import { location, onMount, untrack, watch } from 'cdui-js';
import { H5OpenFlowExitBar } from '../H5OpenFlowExitBar';
import ApplyList from './ApplyList';
import { addAccState, ensureAddAccountAppBackHandler } from './store';
import SelectTypes from './SelectTypes';
import Risk from './Risk';
import Signature from './Signature';
import Success from './Success';
import AddVirtualApplyInfo from './add-virtual-applyinfo';

/** 与步骤对齐；App 可通过 `?step=SelectTypes` 或 `?step=2` 深链 */
const STEP_NAME_MAP: Record<string, number> = {
  ApplyList: 1,
  SelectTypes: 2,
  Risk: 3,
  Signature: 4,
  Success: 5,
};

function resolveInitialStep(raw: string | undefined): number {
  if (!raw) return 1;
  const byName = STEP_NAME_MAP[raw];
  if (byName != null) return byName;
  const n = Number(raw);
  if (Number.isFinite(n) && n >= 1 && n <= 5) return n;
  return 1;
}

/** 仅在进入加开路由时重置。续办打开 virtualFlow 不改 path，不能在这里被清掉。 */
const resetAddAccountFromUrl = () => {
  untrack(() => {
    addAccState.step = resolveInitialStep(location.query.step as string | undefined);
    addAccState.busId = '';
    addAccState.fullName = '';
    addAccState.securitiesAccountType = '';
    addAccState.fundAccountType = '';
    addAccState.needDerivativeTradePermission = false;
    // 深链 /add-virtual-applyinfo 与列表内 virtualFlow 共用本包
    addAccState.virtualFlow = location.path === '/add-virtual-applyinfo';
    addAccState.virtualResume = false;
    addAccState.riskResumeFromList = false;
  });
};

const AddAccount = () => {
  ensureAddAccountAppBackHandler();
  onMount(resetAddAccountFromUrl);
  watch(
    () => location.path,
    (path) => {
      if (path === '/add-account' || path === '/add-virtual-applyinfo') resetAddAccountFromUrl();
    },
  );

  return (
    <div>
      <H5OpenFlowExitBar />
      {addAccState.virtualFlow ? (
        <AddVirtualApplyInfo />
      ) : addAccState.step === 1 ? (
        <ApplyList />
      ) : addAccState.step === 2 ? (
        <SelectTypes />
      ) : addAccState.step === 3 ? (
        <Risk />
      ) : addAccState.step === 4 ? (
        <Signature />
      ) : addAccState.step === 5 ? (
        <Success />
      ) : null}
    </div>
  );
};

export default AddAccount;
